import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import DesktopProfileBottomDisplay728x90Gak from './gak/DesktopProfileBottomDisplay728x90';
import DesktopProfileBottomDisplay728x90Nitro from './nitro/DesktopProfileBottomDisplay728x90';
const DesktopProfileBottomDisplay728x90 = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(DesktopProfileBottomDisplay728x90Gak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopProfileBottomDisplay728x90Nitro, {
        safety: safety
    });
};
DesktopProfileBottomDisplay728x90.displayName = 'DesktopProfileBottomDisplay728x90';
export default DesktopProfileBottomDisplay728x90;
